export default (userAgent = window.navigator.userAgent) => {
  const GOGOGLEBOT_PATTERN = /Googlebot/;

  return GOGOGLEBOT_PATTERN.test(userAgent);
};
